export const List_USERS = "List_USERS";
export const GET_USER_PROFILE = "GET_USER_PROFILE";
export const ADMIN_SUCCESS = "ADMIN_SUCCESS";
export const ADMIN_ERROR = "ADMIN_ERROR";
export const GET_STATISTICS = "GET_STATISTICS";
export const GET_USERS_BY_DATE = "GET_USERS_BY_DATE";
export const GET_USER_SUBSCRIPTION = "GET_USER_SUBSCRIPTION";
